var map = {
	"./template.betgalaxy": 2024,
	"./template.betgalaxy.tsx": 2024,
	"./template.betroyale": 1109,
	"./template.betroyale.tsx": 1109,
	"./template.default": 657,
	"./template.default.tsx": 657,
	"./template.fiestabet": 1110,
	"./template.fiestabet.tsx": 1110,
	"./template.puntgenie": 1111,
	"./template.puntgenie.tsx": 1111,
	"./template.questbet": 1112,
	"./template.questbet.tsx": 1112,
	"./template.sterlingparker": 1113,
	"./template.sterlingparker.tsx": 1113,
	"./template.ts": 212,
	"./template.volcanobet": 1114,
	"./template.volcanobet.tsx": 1114,
	"./template.wellbet": 1115,
	"./template.wellbet.tsx": 1115
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2419;